<template>
  <div>
    <el-menu :default-active="activeIndex"
             router
             class="el-menu-demo"
             :class="name"
             mode="horizontal"
             @select="handleSelect"
             background-color="#545c64"
             text-color="#fff"
             active-text-color="#ffd04b">
      <el-menu-item index="companies">
        <el-select v-model="base.company"
                   @change="handleChangeCompany()"
                   size="mini"
                   placeholder="Select">
          <el-option v-for="item in companies"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-menu-item>
      <template v-for="(route, index) in $router.options.routes"
                v-if="{}.hasOwnProperty.call(route, 'children')">
        <el-menu-item v-for="(menu) in route.children"
                      :index="menu.path" :key="menu.name">
          {{menu.name}}
        </el-menu-item>
        <el-menu-item @click="drawer= true"
                      :key="index">
          Login:{{loginUser.name}}
        </el-menu-item>
      </template>
    </el-menu>

    <el-drawer title="I am the title"
               :visible.sync="drawer"
               :direction="direction"
               :before-close="handleClose">
      <span>Hi, there!</span>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'base',
      'loginUser',
      'companies',
    ]),
  },
  mounted() {
    this.activeIndex = this.$route.path;
  },
  watch: {
    $route(to) {
      this.setPath(to.params);
    },
  },
  methods: {
    setPath(params) {
      console.log('setPath = ', params);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleChangeCompany() {
      this.$store.dispatch('GET_CONFIG_DATA');
    },
    handleClose(done) {
      done();
    },
  },
  data() {
    return {
      name: 'TopNavbar',
      activeIndex: 'organization',
      drawer: false,
      direction: 'rtl',
    };
  },
};
</script>
<style  lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/layout/TopNavbar.vue